export default __webpack_public_path__ + "static/person_2-d071bdda18b583b52a4172548dd7d2e1.png";